import Stepper from "ds/components/Stepper";
import StepperHeader from "ds/components/Stepper/Header";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import useTypedContext from "hooks/useTypedContext";

import { SCHEDULE_SCAN_WIZARD_STEPS_ORDER, SCHEDULE_SCAN_WIZARD_STEP_LABELS } from "../constants";
import { NewScanScheduleContext } from "../context";
import styles from "./styles.module.css";

const ScheduleScanWizardStepper = () => {
  const { currentStep, currentStepIndex, goToStep } = useTypedContext(NewScanScheduleContext);

  return (
    <Stepper className={styles.stepper}>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {SCHEDULE_SCAN_WIZARD_STEPS_ORDER.map((step, index) => (
          <StepperStep
            key={step}
            active={step === currentStep}
            disabled={index > currentStepIndex}
            onClick={index < currentStepIndex ? () => goToStep(step) : undefined}
          >
            {SCHEDULE_SCAN_WIZARD_STEP_LABELS[step]}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default ScheduleScanWizardStepper;
